(function () {
  'use strict';

  if (customElements.get('jb-superstar-colour-carousel')) return;

  function clean(value) {
    return String(value || '').trim();
  }

  class JellybeanSuperstarColourCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised === 'true') return;
      this.dataset.initialised = 'true';
      this.activeGroup = clean(this.dataset.defaultGroup) || 'picnic';
      this.rail = this.querySelector('[data-jb-sc-rail]');
      this.tabs = Array.from(this.querySelectorAll('[data-jb-sc-tab]'));
      this.previousButton = this.querySelector('[data-jb-sc-previous]');
      this.nextButton = this.querySelector('[data-jb-sc-next]');
      this.progressItems = Array.from(this.querySelectorAll('[data-jb-sc-progress] span'));
      this.template = this.querySelector('[data-jb-sc-card-template]');
      this.dialog = this.querySelector('[data-jb-sc-dialog]');
      this.dialogImage = this.querySelector('[data-jb-sc-dialog-image]');
      this.dialogCaption = this.querySelector('[data-jb-sc-dialog-caption]');
      this.dialogClose = this.querySelector('[data-jb-sc-dialog-close]');
      this.bindEvents();
      this.connectToSelector(0);
    }

    bindEvents() {
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.activeGroup = tab.dataset.jbScTab || 'picnic';
          self.render();
        });
      });

      if (this.previousButton) {
        this.previousButton.addEventListener('click', function () {
          self.scrollRail(-1);
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', function () {
          self.scrollRail(1);
        });
      }
      if (this.rail) {
        this.rail.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () {
            self.updateRailState();
          });
        }, { passive: true });
      }
      if (this.dialogClose) {
        this.dialogClose.addEventListener('click', function () {
          self.closeDialog();
        });
      }
      if (this.dialog) {
        this.dialog.addEventListener('click', function (event) {
          if (event.target === self.dialog) self.closeDialog();
        });
        this.dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('jb-superstar-colour-preview-open');
        });
      }

      document.addEventListener('jb:picnic-variant-changed', function (event) {
        if (!self.source || !event.detail) return;
        window.requestAnimationFrame(function () {
          self.render(false);
        });
      });

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(function () {
          self.updateRailState();
        });
      }, { passive: true });
    }

    connectToSelector(attempt) {
      var self = this;
      var source = document.querySelector('jb-picnic-drawer[data-selector-layout="inline"]');
      var ready = source && source.dataset.initialised === 'true' && source.cards && source.cards.length;
      if (!ready) {
        if (attempt < 60) {
          window.setTimeout(function () {
            self.connectToSelector(attempt + 1);
          }, 100);
        }
        return;
      }

      this.source = source;
      this.hidden = false;
      this.render();
    }

    sourceCards(group) {
      if (!this.source || !this.source.cards) return [];
      return this.source.cards.filter(function (card) {
        return clean(card.dataset.group) === group && !card.hidden;
      });
    }

    render(resetScroll) {
      if (!this.source || !this.rail || !this.template) return;
      var self = this;
      var shouldReset = resetScroll !== false;
      var cardsByGroup = {
        picnic: this.sourceCards('picnic'),
        original: this.sourceCards('original')
      };

      if (!cardsByGroup[this.activeGroup].length) {
        this.activeGroup = cardsByGroup.original.length ? 'original' : 'picnic';
      }
      if (!cardsByGroup.picnic.length && !cardsByGroup.original.length) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      this.tabs.forEach(function (tab) {
        var group = tab.dataset.jbScTab;
        var available = cardsByGroup[group] && cardsByGroup[group].length > 0;
        var selected = available && group === self.activeGroup;
        tab.hidden = !available;
        tab.classList.toggle('is-selected', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      ['picnic', 'original'].forEach(function (group) {
        var count = cardsByGroup[group].length;
        var countNode = self.querySelector('[data-jb-sc-count="' + group + '"]');
        if (countNode) countNode.textContent = count;
      });

      this.rail.textContent = '';
      cardsByGroup[this.activeGroup].forEach(function (sourceCard) {
        var fragment = self.template.content.cloneNode(true);
        var card = fragment.querySelector('.jb-superstar-colours__card');
        var zoomButton = fragment.querySelector('[data-jb-sc-zoom]');
        var image = fragment.querySelector('[data-jb-sc-image]');
        var name = fragment.querySelector('[data-jb-sc-name]');
        var sourceImage = sourceCard.querySelector('[data-jb-card-image]');
        var colour = clean(sourceCard.dataset.colour);

        card.dataset.colour = colour;
        card.dataset.group = self.activeGroup;
        image.src = sourceImage ? sourceImage.currentSrc || sourceImage.src : '';
        image.alt = colour;
        name.textContent = colour;
        zoomButton.setAttribute('aria-label', 'Enlarge ' + colour + ' image');

        zoomButton.addEventListener('click', function () {
          self.openDialog(image.src, colour);
        });
        self.rail.appendChild(fragment);
      });

      if (shouldReset) this.rail.scrollLeft = 0;
      window.requestAnimationFrame(function () {
        self.updateRailState();
      });
    }

    scrollRail(direction) {
      if (!this.rail) return;
      var card = this.rail.querySelector('.jb-superstar-colours__card');
      var distance = card ? card.offsetWidth + 18 : this.rail.clientWidth * 0.8;
      this.rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    updateRailState() {
      if (!this.rail) return;
      var maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      var progress = maximum > 0 ? this.rail.scrollLeft / maximum : 0;
      var activeIndex = Math.min(this.progressItems.length - 1, Math.round(progress * (this.progressItems.length - 1)));
      this.progressItems.forEach(function (item, index) {
        item.classList.toggle('is-active', index <= activeIndex);
      });
      if (this.previousButton) this.previousButton.disabled = this.rail.scrollLeft <= 3;
      if (this.nextButton) this.nextButton.disabled = maximum === 0 || this.rail.scrollLeft >= maximum - 3;
    }

    largeImageUrl(path) {
      if (!path) return '';
      try {
        var target = new URL(path, window.location.origin);
        target.searchParams.set('width', '1400');
        return target.toString();
      } catch (error) {
        return path;
      }
    }

    openDialog(imagePath, colour) {
      if (!this.dialog || !imagePath) return;
      this.dialogImage.src = this.largeImageUrl(imagePath);
      this.dialogImage.alt = colour;
      this.dialogCaption.textContent = colour;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('jb-superstar-colour-preview-open');
    }

    closeDialog() {
      if (!this.dialog) return;
      if (this.dialog.open && typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      document.documentElement.classList.remove('jb-superstar-colour-preview-open');
    }
  }

  customElements.define('jb-superstar-colour-carousel', JellybeanSuperstarColourCarousel);
})();
